<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
    <div>
        <div class="position-relative w-100 overflow-hidden">
            <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
            <!-- Placeholder Hero Image -->
            <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/uqQUJVa0cCuylzzHvMOyiE48X5nPhTXXDZMQestv.jpg"
                alt="Hero Image" class="img-fluid w-100" />
            <!-- <div
                class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center w-25 text-start px-3 px-md-5">
                <div class="d-none d-md-block">
                    <h1 class="headingBL title mb-3">
                        Safety + Durability
                        <br />for Every Classroom Display
                    </h1>
                </div>
            </div> -->
        </div>
    </div>
</div>

<!-- Shutter Animation Section -->
<section class="animation-section py-5 text-center">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Shutter Animation</h2>
            <div class="title-underline"></div>
        </div>

        <div class="d-flex justify-content-center align-items-center mx-auto"
            style="max-width: 800px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.1); overflow: hidden;">
            <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/1pgX1T2D5wtmTFo4Lq5vm4BHnonKD5ckwI0n64Np.gif"
                alt="Shutter Animation" class="img-fluid w-100" style="object-fit: cover;">
        </div>
    </div>
</section>

<!-- Icon Features Section -->
<section class="icon-features-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Key Features</h2>
            <div class="title-underline"></div>
        </div>

        <div class="icon-features-grid">
            <div class="feature-item" *ngFor="let feature of iconFeatures">
                <div class="icon-box">
                    <mat-icon>{{ feature.icon }}</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h4 class="feature-title">{{ feature.title }}</h4>
                <p class="feature-desc" [innerHTML]="feature.description"></p>
            </div>
        </div>
    </div>
</section>

<!-- Specifications Section -->
<div class="specifications-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Technical <span>Specifications</span></h2>
            <div class="title-underline"></div>
        </div>
        <mat-tab-group dynamicHeight>
            <mat-tab *ngFor="let section of specSections" [label]="section.label">
                <div class="spec-table-wrapper mt-4">
                    <app-spec-table [headerLabel]="section.headerLabel" [columns]="section.columns"
                        [rows]="section.rows">
                    </app-spec-table>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<!-- Use Cases Section -->
<!-- <section class="use-cases-section py-5">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Use <span>Cases</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="row g-4 justify-content-center">
            <div class="col-md-4 col-lg-3" *ngFor="let useCase of useCases">
                <div class="use-case-card h-100">
                    <div class="card-body text-center d-flex flex-column justify-content-center align-items-center p-4">
                        <mat-icon class="mb-3"
                            style="font-size: 2.5rem; width: 2.5rem; height: 2.5rem; color: var(--color-primary);">check_circle_outline</mat-icon>
                        <h5 class="card-title text-white font-weight-bold mb-0">{{ useCase.subject }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- CTA Section -->
<section class="cta-section text-center">
    <div class="container mb-5">
        <div class="cta-content">
            <h2 class="cta-title mb-4">Secure Your Panel Today</h2>
            <div class="cta-buttons">
                <a routerLink="/form/contactUs" class="btn-premium primary">
                    <mat-icon class="me-2">request_quote</mat-icon>
                    Inquire
                </a>
            </div>
        </div>
    </div>
</section>